import { createStore } from 'vuex';
import { fetchUser } from '@/api/user';  // 這取決於您的 API 函數的位置

export default createStore({
    state: {
        user: null
    },
    mutations: {
        SET_USER(state, user) {
            state.user = user;
        },
        updateRemaining(state, newTime) {
            state.user.remaining = newTime;
        },
    },
    actions: {
        fetchUserData({ commit }) {
            return fetchUser().then(user => {
                commit('SET_USER', user);
            });
        }
    },
    getters: {
        isUserLoaded: state => !!state.user
    }
});
